import { useMemo, useState } from 'react';
import { useGlobalContext, useIoContext } from "../contexts";
import { handleRequest, wait } from "../infra/utils";
import { useStoreActions, useStoreStatic } from "../store/store-context";
import { useStateInRef } from 'seagull';
import { selectors } from "../store/state-selectors";
const exchangeTokenLoader = 'exchangePlaidPublicToken';
const linkTokenLoader = 'linkToken';
export let PlaidMode = /*#__PURE__*/function (PlaidMode) {
  PlaidMode["Vendor"] = "vendor";
  PlaidMode["Customer"] = "customer";
  return PlaidMode;
}({});
export function usePlaidState(props) {
  const getProps = useStateInRef(props);
  const {
    usePlaidLink
  } = useIoContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const [linkToken, setLinkToken] = useState(null);
  const {
    getState
  } = useStoreStatic();
  const options = useMemo(() => {
    return {
      token: linkToken,
      onExit() {
        logBI(10005, {
          success: false
        });
        const {
          onExit
        } = getProps();
        onExit && onExit();
      },
      onSuccess: async publicToken => {
        const businessId = selectors.user.businessId(getState());
        const role = selectors.user.role(getState());
        const userId = selectors.user.id(getState());
        const {
          mode
        } = getProps();
        logBI(10005, {
          success: true
        });
        if (!userId || !businessId || !role) return;
        globalContext.startLoader(exchangeTokenLoader);
        const result = await handleRequest(api.plaid.exchangePublicToken({
          publicToken,
          vendorId: mode.type === PlaidMode.Customer ? mode.vendorId : undefined,
          businessId: mode.type === PlaidMode.Customer ? mode.customerId : businessId,
          relationshipId: mode.type === PlaidMode.Customer ? mode.relationshipId : undefined,
          userId,
          role,
          mode: mode.type
        }));
        if (!result.success) {
          const {
            onError
          } = getProps();
          onError && onError(result.error);
        } else {
          const {
            onSuccess
          } = getProps();
          onSuccess && onSuccess(result.data);
        }
        globalContext.stopLoader(exchangeTokenLoader);
      }
    };
  }, [linkToken]);
  const plaidLink = usePlaidLink(options);
  const getPlaidLink = useStateInRef(plaidLink);
  return {
    async open() {
      const {
        mode
      } = getProps();
      globalContext.startLoader(linkTokenLoader);
      const newLinkToken = await handleRequest(api.plaid.getLinkToken(mode.type, mode.type === PlaidMode.Customer ? {
        relationshipId: mode.relationshipId
      } : undefined));
      if (!newLinkToken.success) {
        const {
          onError
        } = getProps();
        onError && onError(newLinkToken.error);
        globalContext.stopLoader(linkTokenLoader);
        return;
      }
      setLinkToken(newLinkToken.data);

      // Wait till plaidLink is ready.
      while (!getPlaidLink().ready) {
        await wait(50);
      }
      globalContext.stopLoader(linkTokenLoader);
      getPlaidLink().open();
    }
  };
}